export const ROOT = "/admin/employee";
export const VIEW_PROFILE = `${ROOT}/view/:employeeId/`;